import CustomFieldDisplay from 'components/forms/inputs/custom-fields/CustomFieldDisplay';
import { groupFieldsByHeaders } from 'components/forms/inputs/custom-fields/useCustomFields';
import GridItemList from 'components/GridItemList';
import cloneDeep from 'lodash/cloneDeep';
import { useMemo } from 'react';
import { ClassifierData } from 'types/classifiers';
import { CustomField } from 'types/customFields';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

interface Props {
    fields: CustomField[];
    classifiers: ClassifierData[];
    /** Every section spans the full width, for a view that sits in a narrow column. */
    singleColumn?: boolean;
}

const CustomFieldView: React.FC<Props> = ({ fields, classifiers, singleColumn = false }) => {
    const groupedByHeaders = useMemo(() => groupFieldsByHeaders(cloneDeep(fields)), [fields]);

    return (
        <div className={cn('new:gap-(--card-gap) grid gap-6', singleColumn ? 'grid-cols-1' : 'grid-cols-2')}>
            {groupedByHeaders.map(({ id, section, fields, shouldTranslate }, index: number) => (
                <div key={`${id}_${section}`} className={!singleColumn && index > 1 ? 'col-span-2' : undefined}>
                    <GridItemList
                        titleId={section}
                        shouldTranslate={shouldTranslate}
                        size={12}
                        data={fields.map((field) => ({
                            label: field.label ? (field.shouldTranslate ? t(field.label) : field.label) : '',
                            content: <CustomFieldDisplay key={field.id} field={field} classifiers={classifiers} />,
                        }))}
                        key="matter-other"
                    />
                </div>
            ))}
        </div>
    );
};

export default CustomFieldView;
